import React from 'react';

interface Props {
    children: JSX.Element[] | JSX.Element | string;
}

const SubTitle: React.FC<Props> = ({ children }) => (
    <p className="txt-sub txt-emphasis">{children}</p>
);

export default SubTitle;
